import Export from '../export';

/**
 * Create the action
 */

const { thunk, request, success, error } = Export.show((data, fetch) => {
  const formData = new FormData();
  formData.append('size', data.size);
  formData.append('id', data.id);
  formData.append('output', data.output);
  console.log(data.size);
  console.log(data.id);
  console.log(data.output);

  return fetch.post(`export-project/${data.id}`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
